export const CrashIcon = () => (
  <svg
    width="144"
    height="144"
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <circle cx="72" cy="72" r="72" fill="#EDEBE6" />
    <path
      d="M41.3333 91.6489V70.6667H73.4635V87.4466L44.6115 94.2445C42.9374 94.639 41.3333 93.3689 41.3333 91.6489Z"
      fill="#5B5B5B"
    />
    <path
      d="M85.3333 94.6667C75.776 94.6667 68 86.8906 68 77.3333C68 75.1276 66.2057 73.3333 64 73.3333H42.6666C41.9297 73.3333 41.3333 72.737 41.3333 72C41.3333 63.7031 44.5937 55.931 50.5156 50.1172C56.4349 44.3047 64.25 41.1575 72.5742 41.3385C89.1666 41.6419 102.667 55.8333 102.667 72.9726V77.3333C102.667 86.8906 94.8906 94.6667 85.3333 94.6667Z"
      fill="#E86C60"
    />
    <path
      d="M85.3333 88C82.3924 88 80 85.6076 80 82.6666C80 79.7257 82.3924 77.3333 85.3333 77.3333C88.2743 77.3333 90.6667 79.7257 90.6667 82.6666C90.6667 85.6076 88.2743 88 85.3333 88Z"
      fill="#C94F49"
    />
    <path
      d="M85.3333 85.3333C83.8628 85.3333 82.6666 84.1371 82.6666 82.6667C82.6666 81.1962 83.8628 80 85.3333 80C86.8038 80 88 81.1962 88 82.6667C88 84.1371 86.8038 85.3333 85.3333 85.3333Z"
      fill="#444444"
    />
    <path
      d="M85.3333 102.667C84.5964 102.667 84 102.07 84 101.333V84C84 83.263 84.5964 82.6667 85.3333 82.6667C86.0703 82.6667 86.6667 83.263 86.6667 84V101.333C86.6667 102.07 86.0703 102.667 85.3333 102.667Z"
      fill="#5B5B5B"
    />
    <path
      opacity="0.2"
      d="M59.2294 58.0261C61.9004 56.7845 63.3109 54.154 62.3798 52.1507C61.4486 50.1474 58.5284 49.5299 55.8574 50.7714C53.1863 52.0129 51.7758 54.6434 52.7069 56.6467C53.6381 58.65 56.5583 59.2676 59.2294 58.0261Z"
      fill="white"
    />
  </svg>
)
